import { Component, OnInit } from '@angular/core'
import { Firestore, collection, query, orderBy, collectionData } from '@angular/fire/firestore'
import { FirestoreStructure, Lead, LeadReasonLabels } from '@parkupp/core'

@Component({
    selector: 'app-admin-list-enquiries',
    templateUrl: './admin-list-enquiries.component.html',
    styleUrls: ['./admin-list-enquiries.component.scss'],
})
export class AdminListEnquiriesComponent implements OnInit {
    leads: Lead[] = []
    loading = true
    leadReasonLabels = LeadReasonLabels

    constructor(private firestore: Firestore) {}

    ngOnInit(): void {
        this.loadLeads()
    }

    loadLeads() {
        const leadsRef = collection(this.firestore, FirestoreStructure.LEADS)
        const q = query(leadsRef, orderBy('createdAt', 'desc'))

        collectionData(q, { idField: '$key' }).subscribe((data: any[]) => {
            this.leads = data.map((d) => new Lead(d))
            this.loading = false
        })
    }

    formatDate(timestamp: any): string {
        if (!timestamp) return '-'
        if (timestamp.toDate) {
            return timestamp.toDate().toLocaleDateString('en-ZA', {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
            })
        }
        if (timestamp.seconds) {
            return new Date(timestamp.seconds * 1000).toLocaleDateString('en-ZA', {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
            })
        }
        if (timestamp instanceof Date) {
            return timestamp.toLocaleDateString('en-ZA', {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
            })
        }
        return '-'
    }

    getReasonLabel(reason: string): string {
        return (this.leadReasonLabels as any)[reason] || reason || '-'
    }
}
